module.exports = __webpack_public_path__ + "img/sfondo-cous-cous.5fb30e40.png";